package com.appcreator.blueprint.core.properties

import kotlinx.serialization.Serializable

@Serializable
data class BlueprintLink(
    val path: String,
    val params: Map<String, String> = emptyMap()
)